import React from 'react'
import pteLearning from "../img/pte-learning.png"
import pteCoaching from "../img/pte-coaching.webp"
import pteCourse from "../img/pte-course.webp"

export default function PTECoaching() {
    return (
        <div>
            {/* header start */}
            <div className='ieltsHead-bg'>
                <div className="ieltsHead-overlay">
                    <div className="container">
                        <div className="row py-6">
                            <div className="col-md-12">
                                <h1 className='text-white text-center'>Pearson Test Of English Preparation</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* header end */}
            <div className="container">
                <div className="row pt-3 align-items-center justify-content-between">
                    <div className="col-md-6">
                        <h1 className='styled-heading'>Your Personalized <span> Learning Journey</span></h1>
                        <p>Embark on a personalized learning journey towards PTE excellence with our comprehensive course. Tailored to your unique learning style and goals, our program provides expert guidance and resources to excel in the Pearson Test of English exam. Led by experienced instructors, our course emphasizes targeted practice and practical exercises to enhance your skills and confidence.

                            Whether you’re pursuing academic goals, professional aspirations, or immigration objectives, our tailored approach ensures you’re fully prepared to succeed. Join us and unlock your potential to excel in the PTE exam.</p>
                    </div>
                    <div className="col-md-5">
                        <img src={pteLearning} className='img-fluid' alt="ielts-img" />
                    </div>
                </div>
            </div>

            {/* best pte course */}
            <div className="container">
                <div className="row pt-3 align-items-center justify-content-between">
                    <div className="col-md-12 card">
                        <div className="row align-items-center">
                            <div className="col-md-6 card-body">
                                <h4>How Is It A <span>Best PTE Course</span> In Gujranwala?</h4>
                                <li> <i className='fas fa-gem me-2'></i>Highly Experienced experts</li>
                                <li> <i className='fas fa-gem me-2'></i>Best Study material</li>
                                <li> <i className='fas fa-gem me-2'></i>Free mock test</li>
                                <li> <i className='fas fa-gem me-2'></i>PTE test booking</li>
                                <li> <i className='fas fa-gem me-2'></i>One-to-one feedback</li>
                                <li> <i className='fas fa-gem me-2'></i>Modern Computer lab</li>
                                <li> <i className='fas fa-gem me-2'></i>Excellent result record</li>
                                <li> <i className='fas fa-gem me-2'></i>More Than 5 years of experience</li>
                            </div>
                            <div className='col-md-6'>
                                <img src={pteCourse} className='img-fluid' alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* pte acc. & coa. section start */}
            <div className='pteCoaching-bg mt-3'>
                <div className='pteCoaching-overlay'>
                    <div className="container pt-3">
                        <div className="row align-items-center reverse-order justify-content-between">
                            <div className="col-md-6">
                                <img src={pteCoaching} className='img-fluid' alt="ielts-img" />
                            </div>
                            <div className="col-md-6">
                                <h1 className='styled-heading'>PTE Academic And <span> Coaching</span></h1>
                                <p>PTE-Academic or PTE-UKVI is the key to studying/immigrating abroad. Those who want to study/immigrate abroad to places like Australia, New Zealand, Canada, the USA, and the UK can take our PTE coaching classes. Our highly qualified and experienced trainers assist you with PTE test preparation in Gujranwala. To sign up for PTE Course, please fill out the registration form or contact us if you have more questions.</p>
                                <p>You should first understand your current level of English proficiency and the PTE score you need. Taking our Scored Practice Tests will give you a better indication of the score you could achieve on the real test; it also displays your scores for each of the four communication skills (listening, reading, speaking, and writing), so you can see which areas you may need to improve.
                                    If you have taken another English test recently, visit our scoring guide to see how your IELTS or TOEFL scores compare to PTE Academic scores.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* remaining sections */}
            <div className='ptesections-bg my-3'>
                <div className='ptesections-overlay'>
                    <div className="container pt-3">
                        <div className="row">
                            <div className="col-md-12">
                                <h1>Test <span>Format</span></h1>
                                <p>You should become familiar with the structure of PTE Academic if you want to score better. To do so, you need to know the format of the test and the types of questions you can expect. You can consult our guide to the test format or explore each part of the PTE test preparation in Gujranwala.</p>
                            </div>
                            <div className="col-md-12">
                                <h1>Speaking <span>And </span>Writing</h1>
                                <p>Your oral and written communication skills in English will be evaluated through this test which will take 50-60 minutes. This section contains seven questions and is the longest part of the test.</p>
                            </div>
                            <div className="col-md-12">
                                <h1>Read<span>ing</span> </h1>
                                <p>This section contains five different questions and lasts approximately 30 minutes. As PTE Academic is an integrated skills test, one item type (‘Reading and Writing: Fill in the Blanks’) also assesses writing skills.</p>
                            </div>
                            <div className="col-md-12">
                                <h1>Liste<span>ning</span> </h1>
                                <p>There are eight different types of questions and the duration of this part is 30–43 minutes.</p>
                                <li style={{ listStyle: "initial" }}>
                                    Video clips that play automatically and Questions include audio
                                </li>
                                <li style={{ listStyle: "initial" }}>
                                    You will only hear each audio or video clip once. You are allowed to take notes during this time.
                                </li>
                                <p>You can prepare for the test by asking yourself the following questions:</p>
                                <li style={{ listStyle: "initial" }}>
                                    How many questions are asked?
                                </li>
                                <li style={{ listStyle: "initial" }}>
                                    What are the requirements for each question type? How are responses recorded?
                                </li>
                                <li style={{ listStyle: "initial" }}>
                                    How long does each section of the PTE Academic last? What is the time limit for each type of question?
                                </li>
                                <li style={{ listStyle: "initial" }}>
                                    What is the format of each question?
                                </li>
                                <li style={{ listStyle: "initial" }}>
                                    Are there any tasks to complete? Is there a skill assessment? How are responses scored?
                                </li>
                            </div>
                            <div className="col-md-12">
                                <h1>Manifesting Your <span>PTE Preparation</span> </h1>
                                <p>We can assist you in realizing your potential to earn the PTE score you desire. Through learning about the exam format, score guidelines, successful tips and methods, guided study plans, feedback from our experienced tutors, and maintaining a positive outlook, you will refine your preparation.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
